import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';
import {
    ApplicantInfoSummaryDTO,
    FieldApplicantSummary
} from '../../../types/mx/creditoReal/epics';
import {PersonalDataTurboCashStepViewFieldErrorState} from '../../../types/mx/turboCash/reducers';

const personalDataStepView = (state = defaultState.turboCash.ui.personalDataStepView, action) => {
    switch (action.type) {
        case WizardActions.CHANGE_FIRST_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    firstNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_SECOND_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    secondNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_LAST_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    lastNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_SECOND_LAST_NAME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    secondLastNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_DOC_NUMBER_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    docNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_BIRTH_DATE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    birthDateFieldError: action.error
                }
            };
        case WizardActions.CHANGE_CELL_PHONE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    cellPhoneFieldError: action.error
                }
            };
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.name:
            return {
                ...defaultState.turboCash.ui.personalDataStepView,
                fieldErrors: {
                    ...defaultState.turboCash.ui.personalDataStepView.fieldErrors,
                    firstNameFieldError: null,
                    lastNameFieldError: null
                }
            };
        case WizardActions.CHANGE_AMOUNT_DEPENDENTS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    amountDependentsFieldError: action.error
                }
            };
        case WizardActions.CHANGE_CURP_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    cURPFieldError: action.error
                }
            };
        case WizardActions.CHANGE_CIVIL_STATUS_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    civilStatusFieldError: action.error
                }
            };
        case WizardActions.CHANGE_REGIME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    regimeFieldError: action.error
                }
            };
        case WizardActions.CHANGE_ROL_HOME_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    rolHomeFieldError: action.error
                }
            };
        case WizardActions.CHANGE_STUDIES_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    studiesFieldError: action.error
                }
            };
        case WizardActions.CHANGE_HOUSE_TYPE_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    houseTypeFieldError: action.error
                }
            };
        case WizardMXActions.SET_APPLICANT_INFO_DATA_STATE_ACTION.name:
            const fieldSummary:
                FieldApplicantSummary<ApplicantInfoSummaryDTO, PersonalDataTurboCashStepViewFieldErrorState>
                = action.applicantInfo;
            return {
                ...state,
                fieldErrors: fieldSummary.fieldErrors
            };
        case UIActions.CLEAN_STATE_ACTION.name:
            return defaultState.turboCash.ui.personalDataStepView;
        default:
            return state;
    }

};

export default personalDataStepView;